import { gql } from "@apollo/client";

export const GET_ENGINE = gql`
  query Get_Engine($id: ID!) {
    engine(id: $id) {
      phases {
        id
        name
        active
        description
        cypherQuery
      }
    }
  }
`;

export const EDIT_PHASE = gql`
  mutation editPhase($id: ID!, $input: EditPhaseInput!) {
    editPhase(id: $id, input: $input) {
      id
      active
    }
  }
`;
